import React, { useState } from "react";
import "./Page.css";
import useStore from "../store.js";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";

import Button from "../components/Button/Button.js";
import { useParams } from "react-router-dom";
import { useNavigateWithVars } from "../hooks/useNavigateWithVars";
import VideoPlayer from "../components/VideoPlayer/VideoPlayer.js";
import AudioPlayer from "../components/AudioPlayer/AudioPlayer.js";
import PopupBildOverlay from "../components/PopupBildOverlay/PopupBildOverlay.js";
import MaterialIcon from "../components/MaterialIcon/MaterialIcon.js";

const ZoomableImage = ({ src, alt }) => {
  const [showOverlay, setShowOverlay] = useState(false);

  return (
    <>
      <div
        style={{
          position: "relative",
          width: "100%",
          cursor: "pointer",
        }}
        onClick={() => setShowOverlay(true)}
      >
        <img
          src={src}
          alt={alt}
          style={{
            width: "100%",
            height: "auto",
            display: "block",
            border: "1px solid #ccc",
          }}
        />
        <div
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            borderRadius: "50%",
            width: "40px",
            height: "40px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            pointerEvents: "none",
          }}
        >
          <MaterialIcon
            name="zoom_in"
            style={{ color: "white", fontSize: "24px" }}
          />
        </div>
      </div>

      {showOverlay && (
        <PopupBildOverlay
          imageUrl={src}
          onClose={() => setShowOverlay(false)}
        />
      )}
    </>
  );
};

const Page = (props) => {
  const getLocalized = useStore((state) => state.getLocalized);
  const game = useStore((state) => state.game);
  const gameState = useStore((state) => state.gameState);
  const setGameState = useStore((state) => state.setGameState);
  const isHost = useStore((state) => state.isHost);
  const currentHint = useStore((state) => state.currentHint);
  const revealNextHint = useStore((state) => state.revealNextHint);
  const character = useStore((state) => state.character);
  const defaultCharacter = useStore((state) => state.defaultCharacter);
  const defaultGame = useStore((state) => state.defaultGame);
  const navigateTo = useNavigateWithVars();

  const { hintid } = useParams();

  if (!game) return null;
  if (hintid > currentHint + 1)
    return (
      <div className={`Page${props.className ? " " + props.className : ""}`}>
        <BlocksRenderer content={getLocalized("texts", "HintNotOpened")} />
      </div>
    );
  return (
    <div className={`Page${props.className ? " " + props.className : ""} Hint`}>
      {getLocalized("game", "Hints")[hintid - 1].MainText && (
        <BlocksRenderer
          content={getLocalized("game", "Hints")[hintid - 1].MainText}
        />
      )}
      {getLocalized("game", "Hints")[
        hintid - 1
      ].HintMedium?.data?.attributes?.mime.includes("image") && (
        <div
          style={{
            width: "100%",
            marginTop: "1rem",
            marginBottom: "1rem",
          }}
        >
          <ZoomableImage
            src={
              process.env.REACT_APP_CMS_URL +
              getLocalized("game", "Hints")[hintid - 1].HintMedium?.data
                ?.attributes?.url
            }
            alt={
              getLocalized("game", "Hints")[hintid - 1].HintMedium?.data
                ?.attributes?.name
            }
          />
          <p
            style={{
              fontSize: "0.9em",
              color: "#666",
              marginTop: "0.5rem",
              textAlign: "center",
            }}
          >
            <BlocksRenderer
              content={getLocalized("texts", "ZoomableImageHint")}
            />
          </p>
        </div>
      )}

      {getLocalized("game", "Hints")[
        hintid - 1
      ].HintMedium?.data?.attributes?.mime.includes("video") && (
        <VideoPlayer
          url={
            process.env.REACT_APP_CMS_URL +
            getLocalized("game", "Hints")[hintid - 1].HintMedium?.data
              ?.attributes?.url
          }
        />
      )}
      {getLocalized("game", "Hints")[
        hintid - 1
      ].HintMedium?.data?.attributes?.mime.includes("audio") && (
        <AudioPlayer
          url={
            process.env.REACT_APP_CMS_URL +
            getLocalized("game", "Hints")[hintid - 1].HintMedium?.data
              ?.attributes?.url
          }
        ></AudioPlayer>
      )}

      {getLocalized("game", "Hints")[hintid - 1].SubText && (
        <BlocksRenderer
          content={getLocalized("game", "Hints")[hintid - 1].SubText}
        />
      )}

      {gameState <= game?.Rounds && parseInt(hintid) === currentHint + 1 && (
        <>
          {getLocalized("game", "Hints")?.[currentHint + 1]?.Round !==
            gameState &&
          getLocalized("game", "Hints")?.[currentHint]?.WeiterText ? (
            <BlocksRenderer
              content={getLocalized("game", "Hints")?.[currentHint]?.WeiterText}
            />
          ) : (
            <>
              {(() => {
                const nextHint = getLocalized("game", "Hints")[currentHint + 1];
                const isFirstHintOfRound =
                  nextHint?.Round !==
                  getLocalized("game", "Hints")[currentHint]?.Round;

                return (
                  <BlocksRenderer
                    content={getLocalized(
                      "texts",
                      isFirstHintOfRound
                        ? "RoundStartWeiterText"
                        : "DefaultWeiterText",
                    )}
                  />
                );
              })()}
              {defaultGame?.Hints?.[currentHint + 1]?.Character?.data
                ?.attributes?.uid !== character?.uid && (
                <>
                  <b>{`${getLocalized("texts", "Hinweis")} ${currentHint + 2}`}</b>
                </>
              )}
            </>
          )}

          {parseInt(hintid) < getLocalized("game", "Hints").length &&
            getLocalized("game", "Hints")[hintid]?.Round === gameState &&
            getLocalized("texts", "ZuOeffnenVon") &&
            defaultGame?.Hints?.[parseInt(hintid)]?.Character?.data?.attributes
              .uid !== character?.uid && (
              <span>
                ({getLocalized("texts", "ZuOeffnenVon")}{" "}
                {
                  getLocalized("game", "Hints")[hintid].Character?.data
                    ?.attributes?.Name
                }
                )
              </span>
            )}

          {getLocalized("game", "Hints").length > parseInt(hintid) &&
            getLocalized("game", "Hints")[parseInt(hintid)]?.Round <=
              gameState &&
            defaultGame?.Hints?.[parseInt(hintid)]?.Character?.data?.attributes
              .uid === defaultCharacter?.uid && (
              <Button
                onClick={() => {
                  if (currentHint < parseInt(hintid)) {
                    revealNextHint();
                  }
                  navigateTo(`/hint/${parseInt(hintid) + 1}`);
                }}
              >
                <strong>{`${getLocalized("texts", "Hinweis")} ${
                  parseInt(hintid) + 1
                }`}</strong>
              </Button>
            )}
          {isHost &&
            getLocalized("game", "Hints")[hintid]?.Round > gameState && (
              <Button onClick={() => setGameState(gameState + 1)}>
                <strong>{getLocalized("texts", "StartNextRound")}</strong>
              </Button>
            )}
        </>
      )}
    </div>
  );
};

export default Page;
